import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppAnimate from "../../components/AppAnimate";
import Grid from "@material-ui/core/Grid/Grid";
import AppCard from "../../components/layouts/components/AppCard";
import {withSnackbar} from "notistack";
import {Styles} from "../../../config/design/styles";
import {connect, setStore} from "trim-redux";
import {Translate} from "../../../config/Translate";
import {withRouter} from "react-router";
import 'shikwasa/dist/style.css';
import './player.css'
import { Player } from 'shikwasa';
import axios from "axios";
import {defaultVariabls} from "../../../config";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import BreadCrumbs from "../../components/elements/BreadCrumbs";
import List from "@material-ui/core/List/List";
import {ListItem} from "@material-ui/core";
import ListItemAvatar from "@material-ui/core/ListItemAvatar/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Divider from "@material-ui/core/Divider/Divider";
import {truncate} from "../../../config/values";
import AudioPlayer from "./AudioPlayer";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import PlayCircleOutlineRoundedIcon from '@material-ui/icons/PlayCircleOutlineRounded';
import SettingsVoiceRoundedIcon from '@material-ui/icons/SettingsVoiceRounded';
import Rating from "@material-ui/lab/Rating/Rating";
import Button from "@material-ui/core/Button/Button";
import IconButton from "@material-ui/core/IconButton/IconButton";
import ChevronLeftRoundedIcon from "@material-ui/icons/ChevronLeftRounded";
import MicRoundedIcon from "@material-ui/icons/MicRounded";
import {CategoryRounded, CreateRounded, ExpandMoreRounded, MenuBookRounded, PlayArrowRounded} from "@material-ui/icons";
import SubTitle from "../../components/elements/SubTitle";
import Typography from "@material-ui/core/Typography/Typography";
import Title from "../../components/elements/Title";
import scrollToTop from "../../components/elements/ScrollToTop";
import Hidden from "@material-ui/core/Hidden/Hidden";

class PlayerPage extends React.Component {

    state = {
        id:this.props.match.params.id,
        loading:true,
        book:null,
        current_episode:null,
    };
    classes = this.props.classes;
    componentDidMount() {
        this.loadData();

    }


    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/library/get-audiobook/${this.state.id}`, config)
                .then(async response => {
                    await this.setState({
                        book:response.data,
                    })
                    if(!!response.data.current_chapter){
                        await response.data.product.episodes.map(async (episode) => {
                            if(episode.id === response.data.current_chapter){
                                await this.setState({
                                    current_episode: episode
                                })
                            }
                        })
                    }else{
                        await this.setState({
                            current_episode:  response.data.product.episodes[0]
                        })
                    }
                    await this.setState({
                        loading:false,

                    })
                }).catch(error => {
                    console.log(error.response)
                    this.props.history.push('/library')
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    async handleChangeEpisode(current_episode){
        await this.setState({
            loading:true
        })
        await this.setState({
            current_episode
        })
        await this.setState({
            loading:false
        })
        await window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }
    async handleNextEpisode(){
        let {book,current_episode} = this.state;
        book.product.episodes.map((episode,index) => {
            if(episode.id === current_episode.id){
                if(!!book.product.episodes[index + 1]){
                    this.handleChangeEpisode(book.product.episodes[index + 1])
                }
            }
        })
    }
    render(){
        let {book,loading,current_episode} = this.state;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.player}>
                {
                    <Grid container spacing={2} justifyContent="center">
                        {
                            !!loading ?
                                <AppCardLoaderFields/> :
                                <>
                                    <Grid item xs={12} md={9}>
                                        <div className={'player-holder'}>
                                            <Grid container spacing={2} justifyContent="center">
                                                <Grid item xs={12} style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                                                    <div className="player-info-list">
                                                        <div className="img-holder">
                                                            <img src={`${defaultVariabls.uploads}/FileManager/${book.product.thumbnail.name}_medium.${book.product.thumbnail.extension}`}
                                                                 alt={current_episode.name}
                                                            />
                                                        </div>
                                                        <div className="ep-holder">
                                                            <Title align="left">
                                                                {book.product.name}
                                                            </Title>
                                                            <Typography>
                                                                {book.product.description}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                    <Hidden xsDown>
                                                        <div className="logo-holder">
                                                            <img
                                                                className="player-logo"
                                                                src={`${defaultVariabls.website}/images/logo/logo-en.png`}
                                                                alt={Translate.appName}
                                                            />
                                                        </div>
                                                    </Hidden>


                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Divider/>
                                                </Grid>
                                                <Grid item xs={12} md={9}>
                                                    <div className="player-info-list">
                                                        <div className="ep-holder" >
                                                            <Title align="left" >
                                                                {current_episode.name}
                                                            </Title>
                                                        </div>
                                                    </div>

                                                    <AudioPlayer
                                                        episode={current_episode}
                                                        book={book}
                                                        handleNextTrack={() => this.handleNextEpisode()}
                                                    />
                                                    <Typography style={{color:"#dbdbdb"}}>
                                                        {current_episode.description}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <SubTitle align="left" color="secondary" style={{display:"flex",alignItems:"center"}}>{Translate.episodesIndex} <ExpandMoreRounded fontSize="small"/></SubTitle>

                                                    <Divider />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <List style={{padding:5}}>
                                                        <Grid container spacing={2}>
                                                            {
                                                                book.product.episodes.map((episode,index) => (
                                                                    <Grid item xs={12} md={6}key={index}>
                                                                        <ListItem
                                                                            className={episode.file_id === current_episode.file_id ? "player-playlist active" : "player-playlist"}
                                                                            alignItems="flex-start"
                                                                            button
                                                                            onClick={() => this.handleChangeEpisode(episode)}
                                                                        >
                                                                            <ListItemAvatar>
                                                                                <img alt={episode.name}
                                                                                     src={
                                                                                         !!episode.thumbnail ?
                                                                                             `${defaultVariabls.uploads}/FileManager/${episode.thumbnail.name}_small.${episode.thumbnail.extension}`:
                                                                                             `${defaultVariabls.uploads}/FileManager/${book.product.thumbnail.name}_small.${book.product.thumbnail.extension}`
                                                                                     }/>
                                                                            </ListItemAvatar>
                                                                            <ListItemText
                                                                                primary={!!episode.name ? episode.name : Translate.episode+" "+ (index + 1)}
                                                                                secondary={truncate(episode.description,30)}
                                                                            />
                                                                            <ListItemSecondaryAction style={{display:"flex"}}>
                                                                                <PlayArrowRounded color="secondary"/>
                                                                            </ListItemSecondaryAction>
                                                                        </ListItem>
                                                                    </Grid>
                                                                ))
                                                            }
                                                        </Grid>
                                                    </List>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Grid>
                                </>
                        }
                    </Grid>
                }
            </AppAnimate>
        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(PlayerPage))));